/* eslint-disable react-hooks/exhaustive-deps */
import {Box, Button, Flex, Spinner, Text, VStack} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {ListResponse} from "../services/responses";
import {useAPI} from "../hooks/useAPI";
import {useUIManager} from "../hooks/useUIManager";
import {ListCard} from "./ListCard";

interface ListsTabProps {
  username: string;
  isOwnProfile: boolean;
}

const ListsTab = ({username, isOwnProfile}: ListsTabProps) => {
  const api = useAPI();
  const uiManager = useUIManager();
  const [loaded, setLoaded] = useState(false);
  const [lists, setLists] = useState<ListResponse[]>([]);

  useEffect(() => {
    const request = isOwnProfile ? api.getLists() : api.getListsByUsername(username);
    request
      .then((response) => {
        setLists(response);
        setLoaded(true);
      })
      .finally(() => uiManager.toggleNeedReloadLists(false));
  }, [uiManager.needReloadLists, username, isOwnProfile]);

  if (!loaded) {
    return <Flex justifyContent="center" alignItems="center" mt="3rem">
      <Spinner size="xl"/>
    </Flex>;
  }

  return <>
    {isOwnProfile && (
      <Flex justifyContent="flex-end" mb={3}>
        <Button colorScheme="brand" onClick={() => uiManager.toggleListModal(true)}>Create list</Button>
      </Flex>
    )}

    {!!lists.length && (
      <Flex justifyContent="space-between" flexWrap="wrap" gap={3}>
        {lists.map((list) => (
          <ListCard key={list.uuid} list={list} username={username} editable={isOwnProfile}/>
        ))}
      </Flex>
    )}

    {!lists.length && (
      <Box textAlign="center" mt="3rem">
        <VStack color="gray.500" fontSize={{base: "xs", md: "sm"}} gap={0}>
          <Text fontSize={{base: "36px", md: "48px"}}>¯\_(ツ)_/¯</Text>
          <Text>{isOwnProfile ? 'You have no lists yet.' : 'There are no lists here yet.'}</Text>
          {isOwnProfile && <Text>Create one for a birthday, New Year or any other occasion.</Text>}
        </VStack>
      </Box>
    )}
  </>;
};

export default observer(ListsTab);
